import AssessmentsSerializer from './base';
import { scaleNumericGrade } from 'linced-app/utils/grades';

export default class Grade extends AssessmentsSerializer {
  normalize(model, hash) {
    // Apply numeric scale if applicable.
    let scale = hash.numericScale ?? 0;
    hash.numericAwarded = hash.numericAwarded ?? 0;
    if (scale !== 0 && hash.numericAwarded !== 0) {
      hash.numericAwarded *= Math.pow(10, scale);
      if (scale < 0) {
        // If the grade is fractional, round to the applicable number of decimal places.
        hash.numericAwarded = hash.numericAwarded.toFixed(Math.abs(scale));
      }

      // Clear scale factor so that it can't be reapplied.
      hash.numericScale = 0;
    }
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);

    // Calculate numeric scale if applicable.
    return scaleNumericGrade(hash);
  }
}
